export const REQ_TECHNICIAN_SUCCESS = "REQ_TECHNICIAN_SUCCESS"